module.exports = __webpack_public_path__ + "static/media/commerce.59b37965.svg";